var _path, _g, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3644_32036",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 22,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.13745H27V29.0001H5V2.13745Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3644_32036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.5002C26.1039 19.8578 19.8211 25.1002 17.2281 27.09C16.5682 27.5963 15.6727 27.6017 15.0068 27.1034C12.3613 25.1238 5.89704 19.8676 5.5 15.5002C5.5 9.82717 9.83422 2.00024 16.1223 2.00024C22.4103 2.00024 26.5 9.82717 26.5 15.5002Z",
    fill: "#3A946A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 11,
    fill: "#3A946A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13,
    r: 9,
    fill: "#3A946A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18C12.225 18 11.9896 17.9021 11.7938 17.7063C11.5979 17.5104 11.5 17.275 11.5 17V10C11.5 9.725 11.5979 9.48958 11.7938 9.29375C11.9896 9.09792 12.225 9 12.5 9H14.6C14.7167 8.7 14.9 8.45833 15.15 8.275C15.4 8.09167 15.6833 8 16 8C16.3167 8 16.6 8.09167 16.85 8.275C17.1 8.45833 17.2833 8.7 17.4 9H19.5C19.775 9 20.0104 9.09792 20.2063 9.29375C20.4021 9.48958 20.5 9.725 20.5 10V17C20.5 17.275 20.4021 17.5104 20.2063 17.7063C20.0104 17.9021 19.775 18 19.5 18H12.5ZM16 9.625C16.1083 9.625 16.1979 9.58958 16.2688 9.51875C16.3396 9.44792 16.375 9.35833 16.375 9.25C16.375 9.14167 16.3396 9.05208 16.2688 8.98125C16.1979 8.91042 16.1083 8.875 16 8.875C15.8917 8.875 15.8021 8.91042 15.7313 8.98125C15.6604 9.05208 15.625 9.14167 15.625 9.25C15.625 9.35833 15.6604 9.44792 15.7313 9.51875C15.8021 9.58958 15.8917 9.625 16 9.625ZM16 14C16.4833 14 16.8958 13.8292 17.2375 13.4875C17.5792 13.1458 17.75 12.7333 17.75 12.25C17.75 11.7667 17.5792 11.3542 17.2375 11.0125C16.8958 10.6708 16.4833 10.5 16 10.5C15.5167 10.5 15.1042 10.6708 14.7625 11.0125C14.4208 11.3542 14.25 11.7667 14.25 12.25C14.25 12.7333 14.4208 13.1458 14.7625 13.4875C15.1042 13.8292 15.5167 14 16 14ZM12.5 17H19.5V16.425C19.05 15.9833 18.5271 15.6354 17.9313 15.3812C17.3354 15.1271 16.6917 15 16 15C15.3083 15 14.6646 15.1271 14.0688 15.3812C13.4729 15.6354 12.95 15.9833 12.5 16.425V17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedic);
export default __webpack_public_path__ + "static/media/medic.42004b57b4139f35e9d0f9a643865c51.svg";
export { ForwardRef as ReactComponent };